export default "__VITE_ASSET__DBME$u9U__"